import React from "react";
import "./weather.css";

export default function WeatherTemperature(props) {
    return(
        <div className="WeatherTemperature">
            <span className="TemperatureDisplayValue">{Math.round(props.celsius)}
            </span>
            <span className="TemperatureDisplayUnit">°C
            </span>
        </div>
    );
    }

